import { useEffect, useState } from "react";
import updateSubcriptions from "../function/updateSubcriptions";
import { toast } from "react-toastify";
import getSubcriptionsDetailId from "../function/getSubcriptionsDetailId";

type EditSubcriptionsModalProps = {
    subcriptionId?: number;
    onClose?: () => void;
}


const EditSubcriptionsModal = ({ subcriptionId, onClose }: EditSubcriptionsModalProps) => {

    // Fetch features for the given subscription ID
    const [subscriptionName, setSubscriptionName] = useState<string>("");
    const [subscriptionDescription, setSubscriptionDescription] = useState<string>("");
    const [subscriptionPrice, setSubscriptionPrice] = useState<number>(0);

    useEffect(() => {
        if (subcriptionId) {
            getSubcriptionsDetailId(subcriptionId).then((data) => {
                if (data) {
                    setSubscriptionName(data.name);
                    setSubscriptionDescription(data.description);
                    setSubscriptionPrice(data.price);
                }
            });
        }
    }, [subcriptionId]);

    async function handleSaveChanges() {
        await updateSubcriptions(
            subcriptionId!,
            subscriptionName,
            subscriptionDescription,
            Number(subscriptionPrice)
        ).then((res) => {
            if (res) {
                toast.success("Subscription updated successfully");
            }
        }).catch((error) => {
            console.error("Error updating subscription:", error);
            toast.error("Failed to update subscription");
        });
        onClose && onClose();
    }

    return (
        <div className="px-2 py-4 flex flex-col gap-4">
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2 w-full">
                        <div className="flex flex-col gap-2">
                            <label htmlFor="subscriptionName" className="font-medium">Subscription Name</label>
                            <input
                                value={subscriptionName}
                                onChange={(e) => setSubscriptionName(e.target.value)}
                                type="text" id="subscriptionName" className="border p-2 rounded-lg w-full" placeholder="Enter subscription name" />
                        </div>
                        <div className="flex flex-col gap-2">
                            <label htmlFor="subscriptionDescription" className="font-medium">Subscription Description</label>
                            <textarea
                                value={subscriptionDescription}
                                onChange={(e) => setSubscriptionDescription(e.target.value)}
                                id="subscriptionDescription" className="min-h-[100px] border p-2 rounded-lg w-full" placeholder="Enter subscription description"></textarea>
                        </div>
                        <div className="flex flex-col gap-2">
                            <label htmlFor="subscriptionPrice" className="font-medium">Subscription Price</label>
                            <input
                                value={subscriptionPrice}
                                onChange={(e) =>
                                    setSubscriptionPrice(Number(e.target.value))}
                                type="number" id="subscriptionPrice" className="border p-2 rounded-lg w-full" placeholder="Enter subscription price" />
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-4 mt-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 transition-colors">
                        Cancel
                    </button>
                    <button
                        onClick={handleSaveChanges}
                        className="px-4 py-2 rounded-lg bg-blue-600 !text-white hover:bg-blue-700 transition-colors">
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
}
export default EditSubcriptionsModal;